// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"806":"145c3d8db6ea259e","4537":"a9b109d2961b05c0","4583":"34ba9a8b8ba1db27"}[chunkId] + ".js";
};